import type { CSSProperties } from "react";

/** Bloco de carregamento (shimmer). */
export function Skeleton({
  width = "100%",
  height = 14,
  radius = 6,
  style,
}: {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: CSSProperties;
}) {
  return (
    <span
      className="skeleton"
      style={{ width, height, borderRadius: radius, display: "block", ...style }}
      aria-hidden
    />
  );
}

/** Lista de linhas skeleton (ex.: itens de conversa/usuário). */
export function SkeletonList({ rows = 6, gap = 10 }: { rows?: number; gap?: number }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap }} aria-hidden aria-busy="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <Skeleton width={`${55 + ((i * 13) % 35)}%`} height={12} />
          <Skeleton width={`${30 + ((i * 7) % 25)}%`} height={9} />
        </div>
      ))}
    </div>
  );
}

/** Skeleton de uma mensagem/resposta (para transição de histórico). */
export function SkeletonMessages({ blocks = 3 }: { blocks?: number }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24, padding: "8px 0" }} aria-busy="true">
      {Array.from({ length: blocks }).map((_, i) => (
        <div key={i} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Skeleton width={i % 2 === 0 ? "40%" : "55%"} height={13} />
          <Skeleton width="92%" height={11} />
          <Skeleton width="85%" height={11} />
          <Skeleton width="70%" height={11} />
        </div>
      ))}
    </div>
  );
}
